// @ts-nocheck

const trapFocus = element => {
  const focusable = element.querySelector(
    'button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (focusable) focusable.focus();
};

const removeTrapFocus = () => {
  if (document.activeElement) document.activeElement.blur();
};

const onAnimationEnd = (element, callback) => {
  const handleAnimationEnd = event => {
    if (event.target === element) {
      element.removeEventListener('animationend', handleAnimationEnd);
      element.removeEventListener('transitionend', handleAnimationEnd);
      callback();
    }
  };

  element.addEventListener('animationend', handleAnimationEnd);
  element.addEventListener('transitionend', handleAnimationEnd);

  setTimeout(() => {
    element.removeEventListener('animationend', handleAnimationEnd);
    element.removeEventListener('transitionend', handleAnimationEnd);
    callback();
  }, 500);
};

class CourseMaterialsMobileDrawer {
  constructor() {
    this.drawer = null;
    this.overlay = null;
    this.isOpen = false;
    this.mobileEventsRegistered = false;
    this.init();
  }

  init() {
    this.createDrawerElements();
    this.bindEvents();
    this.setupResponsiveHandling();
  }

  createDrawerElements() {
    this.drawer = document.createElement('div');
    this.drawer.className = 'course-materials-drawer dialog-drawer';
    this.drawer.setAttribute('role', 'dialog');
    this.drawer.setAttribute('aria-modal', 'true');
    this.drawer.setAttribute('aria-labelledby', 'drawer-title');

    this.overlay = document.createElement('div');
    this.overlay.className = 'course-materials-drawer-overlay';

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.drawer);

    this.setupDrawerContent();
  }

  setupDrawerContent() {
    const sidebarContent = document.querySelector('.filters-content');
    if (!sidebarContent) return;

    this.originalSidebarParent = sidebarContent.parentNode;
    this.originalSidebarContent = sidebarContent;

    const drawerHeader = document.createElement('div');
    drawerHeader.className = 'drawer__header drawer-animated-element';
    drawerHeader.style.setProperty('--drawer-animation-index', '1');
    drawerHeader.innerHTML = `
      <h2 id="drawer-title" class="drawer__title">Course Materials</h2>
      <button class="drawer__close button-unstyled" aria-label="Close drawer">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `;

    const drawerContentWrapper = document.createElement('div');
    drawerContentWrapper.className = 'drawer__content drawer-animated-element';
    drawerContentWrapper.style.setProperty('--drawer-animation-index', '2');

    this.drawer.appendChild(drawerHeader);
    this.drawer.appendChild(drawerContentWrapper);

    this.drawerContentWrapper = drawerContentWrapper;
  }

  moveSidebarToDrawer() {
    if (!this.originalSidebarContent || !this.drawerContentWrapper) return;

    this.drawerContentWrapper.appendChild(this.originalSidebarContent);

    const originalCloseBtn =
      this.originalSidebarContent.querySelector('#close-filters');
    if (originalCloseBtn) {
      originalCloseBtn.style.display = 'none';
    }
  }

  moveSidebarToDesktop() {
    if (!this.originalSidebarContent || !this.originalSidebarParent) return;

    // Insert at the beginning so order stays: filters-content, then form-actions (matches original DOM order).
    // appendChild would put the block last and reorder sidebar vs. main content incorrectly.
    const firstChild = this.originalSidebarParent.firstChild;
    this.originalSidebarParent.insertBefore(
      this.originalSidebarContent,
      firstChild
    );

    const originalCloseBtn =
      this.originalSidebarContent.querySelector('#close-filters');
    if (originalCloseBtn) {
      originalCloseBtn.style.display = '';
    }
  }

  bindEvents() {
    const closeBtn = this.drawer.querySelector('.drawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    this.bindDrawerFormEvents();
  }

  bindDrawerFormEvents() {}

  bindMobileEvents() {
    if (this.mobileEventsRegistered) return;

    this.handleCourseAdded = event => {
      if (this.isOpen && window.innerWidth < 968) {
        setTimeout(() => {
          this.close();
        }, 300);
      }
    };

    this.handleStudentSubmitted = event => {
      if (this.isOpen && window.innerWidth < 968) {
        const detail = event.detail;
        if (detail) {
          if (detail.onComplete) {
            const originalOnComplete = detail.onComplete;
            detail.onComplete = () => {
              originalOnComplete();
              setTimeout(() => {
                this.close();
              }, 500);
            };
          }

          if (detail.onError) {
            const originalOnError = detail.onError;
            detail.onError = () => {
              originalOnError();
            };
          }
        }
      }
    };

    document.addEventListener('sidebar:courseAdded', this.handleCourseAdded);
    document.addEventListener(
      'sidebar:studentSubmitted',
      this.handleStudentSubmitted
    );

    this.mobileEventsRegistered = true;
  }

  setupResponsiveHandling() {
    this.handleResize();
    window.addEventListener('resize', () => this.handleResize());
  }

  handleResize() {
    const isMobile = window.innerWidth < 968;

    if (isMobile) {
      this.enableMobileMode();
    } else {
      this.enableDesktopMode();
    }
  }

  enableMobileMode() {
    const desktopSidebar = document.getElementById('filters-section');
    const panelToggleBtn = document.querySelector('.panel-toggle-btn');

    if (desktopSidebar) {
      desktopSidebar.style.display = 'none';
    }

    if (panelToggleBtn) {
      panelToggleBtn.style.display = 'none';
    }

    this.moveSidebarToDrawer();
    this.showMobileTrigger();
    this.bindMobileEvents();
  }

  enableDesktopMode() {
    this.moveSidebarToDesktop();

    const desktopSidebar = document.getElementById('filters-section');
    const panelToggleBtn = document.querySelector('.panel-toggle-btn');

    if (desktopSidebar) {
      desktopSidebar.style.display = '';
    }

    this.hideMobileTrigger();

    if (this.isOpen) {
      this.close();
    }
  }

  showMobileTrigger() {
    let trigger = document.getElementById('mobile-course-trigger');

    if (!trigger) {
      trigger = this.createMobileTrigger();
    }

    if (trigger) {
      trigger.style.display = 'block';
    }
  }

  hideMobileTrigger() {
    const trigger = document.getElementById('mobile-course-trigger');
    if (trigger) {
      trigger.style.display = 'none';
    }
  }

  createMobileTrigger() {
    const trigger = document.createElement('div');
    trigger.id = 'mobile-course-trigger';
    trigger.className = 'mobile-course-trigger';

    trigger.innerHTML = `
      <button class="mobile-course-btn" type="button">
        <span class="mobile-course-text">Add/edit courses</span>
      </button>
    `;

    const productsSection = document.getElementById('products-section');
    const headerSection =
      document.querySelector('.cmrp-materials-main-header') ||
      productsSection?.querySelector('.right-panel-header');

    if (headerSection) {
      headerSection.appendChild(trigger);
    } else if (productsSection) {
      productsSection.insertBefore(trigger, productsSection.firstChild);
    } else {
      const sidebar = document.getElementById('filters-section');
      if (sidebar && sidebar.parentNode) {
        sidebar.parentNode.insertBefore(trigger, sidebar.nextSibling);
      }
    }

    const btn = trigger.querySelector('.mobile-course-btn');
    if (btn) {
      btn.addEventListener('click', () => this.open());
    }

    return trigger;
  }

  open() {
    if (this.isOpen) return;
    if (!this.drawer || !this.overlay) return;

    this.isOpen = true;

    this.overlay.style.display = 'block';
    this.drawer.style.display = 'flex';

    this.drawer.style.transform = 'translateX(-100%)';

    requestAnimationFrame(() => {
      this.drawer.setAttribute('open', '');
      this.drawer.classList.add('drawer-open');
      this.overlay.classList.add('active');

      setTimeout(() => {
        trapFocus(this.drawer);
      }, parseInt(getComputedStyle(document.documentElement).getPropertyValue('--drawer-animation-speed').replace('s', '')) * 1000 || 400);
    });

    document.body.style.overflow = 'hidden';
  }

  close() {
    if (!this.isOpen) return;

    this.drawer.classList.remove('drawer-open');
    this.overlay.classList.remove('active');

    removeTrapFocus();

    const animationSpeed =
      parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--drawer-animation-speed')
          .replace('s', '')
      ) * 1000 || 400;

    setTimeout(() => {
      this.isOpen = false;
      this.drawer.removeAttribute('open');

      this.overlay.style.display = 'none';
      this.drawer.style.display = 'none';

      document.body.style.overflow = '';
    }, animationSpeed);
  }

  toggle() {
    return this.isOpen ? this.close() : this.open();
  }

  isDrawerOpen() {
    return this.isOpen;
  }

  destroy() {
    if (this.drawer) {
      this.drawer.remove();
    }
    if (this.overlay) {
      this.overlay.remove();
    }

    const trigger = document.getElementById('mobile-course-trigger');
    if (trigger) {
      trigger.remove();
    }

    window.removeEventListener('resize', this.handleResize);

    if (this.mobileEventsRegistered) {
      document.removeEventListener(
        'sidebar:courseAdded',
        this.handleCourseAdded
      );
      document.removeEventListener(
        'sidebar:studentSubmitted',
        this.handleStudentSubmitted
      );
      this.mobileEventsRegistered = false;
    }
  }
}

window.CourseMaterialsMobileDrawer = CourseMaterialsMobileDrawer;

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    if (!window.courseMaterialsMobileDrawer) {
      window.courseMaterialsMobileDrawer = new CourseMaterialsMobileDrawer();
    }
  }, 100);
});

// Also try to initialize immediately if DOM is already ready
if (document.readyState === 'loading') {
  // DOM is still loading
} else {
  // DOM is already loaded
  setTimeout(() => {
    if (!window.courseMaterialsMobileDrawer) {
      window.courseMaterialsMobileDrawer = new CourseMaterialsMobileDrawer();
    }
  }, 100);
}
